import { useCameraViews } from "hooks/playcanvas/camera-views";
export var CanvasEffects = function (_a) {
    var app = _a.app, camera = _a.camera, setPickerDisabled = _a.setPickerDisabled;
    useCameraViews(app, camera, setPickerDisabled);
    return null;
};
